import * as React from "react";
export function conditionalValuesToCSSVars(obj, prefix) {
  if (!obj)
    return {};
  if (typeof obj === "number" || typeof obj === "string")
    return { [`--${prefix}`]: obj };
  return Object.fromEntries(
    Object.entries(obj).filter(([key, value]) => value !== void 0).flatMap(([key, value]) => {
      if (typeof value === "object") {
        return Object.entries(value).map(
          ([key2, value2]) => [`--${prefix}-${key}-${key2}`, value2]
        );
      } else {
        return [[`--${prefix}-${key}`, value]];
      }
    })
  );
}
export function cloneChildrenWithAttributes(children, attributes) {
  if (children === null || children === void 0) {
    return null;
  } else if (Array.isArray(children) || typeof children === "string" || typeof children === "number" || typeof children === "boolean" || children[Symbol.iterator]) {
    return /* @__PURE__ */ React.createElement("div", { style: attributes.style, className: attributes.className, id: attributes.id, ...attributes.otherProps }, children);
  } else {
    return React.cloneElement(children, {
      style: { ...children?.props?.style, ...attributes.style },
      className: ((children?.props?.className ?? "") + " " + attributes.className).trim(),
      id: attributes.id ?? children?.props?.id,
      ...attributes.otherProps
    });
  }
}
